const API_URL = {
  CONTENTS: "/contents",
  EXT_PERMIT: "/ext_permit",
  FILES: "/files",
  MEMBERS: "/members",
  MESSAGE: "/message",
  RESERVATION: "/reservation",
  SEQUENCE: "/sequence",
  STATS: "/stats",
  STATS_VIRTUAL: "/statsVirtual",
  TASK: "/task",
  VARIABLES: "/variables",
};

export default API_URL;